// A password staff just set for someone (legacy AdminWeb "Set Password"): shown this once to copy and hand over, then
// hidden for good — the API keeps only its hash, so it can never be shown again.
import { useState } from 'react';

export const SET_PASSWORD_CONFIRM = (email: string) =>
  `Set a new password for ${email}? Their current password stops working and they are signed out everywhere.`;

export function ShownPassword({ email, password, onDone }: { email: string; password: string; onDone: () => void }) {
  const [copyFailed, setCopyFailed] = useState(false);

  async function copy() {
    try {
      await navigator.clipboard.writeText(password);
      onDone();
    } catch {
      // no clipboard (an http page, a denied permission): leave it on screen to copy by hand
      setCopyFailed(true);
    }
  }

  return (
    <div className="qc-auth-error" role="alert" style={{ marginTop: 16 }}>
      <strong>New password for {email}</strong> — copy it now: this is the only time it is shown.
      <p style={{ margin: '10px 0' }}>
        <code aria-label="New password" style={{ fontSize: '1rem', userSelect: 'all' }}>
          {password}
        </code>
      </p>
      {copyFailed && <p style={{ margin: '0 0 10px' }}>Couldn't copy here: select the password and copy it by hand.</p>}
      <div style={{ display: 'flex', gap: 10 }}>
        <button type="button" className="qc-button-ghost" onClick={() => void copy()}>
          Copy password
        </button>
        {copyFailed && (
          <button type="button" className="qc-button-ghost" onClick={onDone}>
            I have copied it
          </button>
        )}
      </div>
    </div>
  );
}
